import React, { useState } from "react";
import { Button, Select, Tooltip } from "antd";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import { ProgrammingLanguage } from "../../../../Interface/Index";

interface AiAssessmentCodeEditorHeaderProps {
  languages: ProgrammingLanguage[];
  handleSelectLanguage: (language: ProgrammingLanguage | null) => void;
  selectedLanguage: ProgrammingLanguage | null;
  handleCodingFullscreenToggle: () => void;
  isCodingFullscreen: boolean;
}

const AiAssessmentCodeEditorHeader: React.FC<
  AiAssessmentCodeEditorHeaderProps
> = ({
  languages,
  handleSelectLanguage,
  selectedLanguage,
  handleCodingFullscreenToggle,
  isCodingFullscreen,
}) => {
  const languageOptions = languages.map((language) => ({
    label: language.name,
    value: language.id,
  }));
  const [filteredOptions, setFilteredOptions] = useState(languageOptions);

  return (
    <div className="ai-assessment-code-editor-header">
      <div className="ai-assessment-code-editor-language-selector">
        <Select
          value={selectedLanguage?.id}
          options={filteredOptions}
          style={{ width: 200 }}
          placeholder="Select a language"
          onChange={(value) => {
            const selectedLanguage = languages.find(
              (language) => language.id === value
            );
            if (selectedLanguage) {
              handleSelectLanguage(selectedLanguage);
            }
          }}
          showSearch
          filterOption={false}
          onSearch={(searchText) => {
            const filtered = languageOptions.filter((option) =>
              option.label.toLowerCase().includes(searchText.toLowerCase())
            );
            setFilteredOptions(filtered);
          }}
          onFocus={() => setFilteredOptions(languageOptions)}
          getPopupContainer={(trigger) => trigger.parentElement!}
          allowClear
          onClear={() => {
            handleSelectLanguage(null);
          }}
        />
      </div>
      <div className="ai-assessment-code-editor-fullscreen-button">
        <Tooltip
          title={
            !isCodingFullscreen ? "Expand to fullscreen" : "Back to normal"
          }
          placement="bottom"
        >
          <Button
            icon={
              !isCodingFullscreen ? (
                <FullscreenOutlined />
              ) : (
                <FullscreenExitOutlined />
              )
            }
            type="text"
            onClick={handleCodingFullscreenToggle}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default AiAssessmentCodeEditorHeader;
